import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { SearchKeyFilter } from '../../../../../app/AppUtils';
import RegisterCard from '../../../../register/RegisterCard';
import { fetchAllRegisterForEmployee, fetchRegisterForEmployee, setPeriodsList } from '../../../../register/registerSlice';
import ContentLoader from '../../../../subcomponents/ContentLoader';
import NoContentDisplay from '../../../../subcomponents/NoContentDisplay';
import { setStudentRegisterPage } from '../../searchStudentSlice';
import RegisterSubprogramCard from '../../../../register/RegisterSubprogramCard';

export default function SearchStudentRegisterTab({ studentId }) {
    const dispatch = useDispatch();

    const { register, registerAll, registerStatus, registerAllStatus, periods, employeeShowPast } = useSelector((state) => state.register);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { searchStudentStatus, studentRegisterReasonMode, studentRegisterFilter } = useSelector((state) => state.search.student);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { activeDepartment } = useSelector((state) => state.settings.theme);

    const [registerContent, setRegisterContent] = useState()
    const [registerContentStatus, setRegisterContentStatus] = useState()
    const [registerSubprograms, setRegisterSubprograms] = useState()
    const [registerBlocked, setRegisterBlocked] = useState()

    // Get student register data if enabled and selected
    useEffect(() => {
        var departmentId = siomSettings.useMultipleDepartments && activeDepartment ? activeDepartment[0]?.id : null
        dispatch(setStudentRegisterPage("REGISTER"));

        if (studentRegisterReasonMode && (registerAllStatus === null || registerAllStatus === "failed"))
            dispatch(fetchAllRegisterForEmployee({ studentId: studentId, showPast: employeeShowPast, departmentId: departmentId }))

        if (!studentRegisterReasonMode && (registerStatus === null || registerStatus === "failed"))
            dispatch(fetchRegisterForEmployee({ studentId: studentId, departmentId: departmentId }));

    }, [dispatch, studentId, studentRegisterReasonMode, employeeShowPast]);

    // Set register content
    useEffect(() => {
        if (studentRegisterReasonMode) {
            setRegisterBlocked(false);
            setRegisterContent(registerAll?.employeeRegisterActivities);
            setRegisterContentStatus(registerAllStatus);
            setRegisterSubprograms(registerAll?.registerSubprograms);
        } else {
            setRegisterBlocked(register?.subscriptionBlocked);
            setRegisterContent(register?.registerActivities);
            setRegisterContentStatus(registerStatus);
            setRegisterSubprograms(register?.registerSubprograms);
        }
    }, [studentRegisterReasonMode, registerStatus, registerAllStatus]);

    // Set register periods
    useEffect(() => {
        if (studentRegisterReasonMode && registerAllStatus === "success")
            dispatch(setPeriodsList(filterUniquePeriods(registerAll?.employeeRegisterActivities)));

        if (!studentRegisterReasonMode && registerStatus === "success")
            dispatch(setPeriodsList(filterUniquePeriods(register?.registerActivities)));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [registerStatus, registerAllStatus]);

    const filterUniquePeriods = (registerActivities) => {
        if (registerActivities) {
            const allPeriods = registerActivities.flatMap(item => item.periods);
            const uniquePeriods = new Map();

            allPeriods.forEach((item) => {
                const key = JSON.stringify(item.name);
                if (!uniquePeriods.has(key)) {
                    uniquePeriods.set(key, item);
                }
            });

            const uniquePeriodsArray = Array.from(uniquePeriods.values());
            uniquePeriodsArray.sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

            return uniquePeriodsArray;
        }
    };

    const handleFilterResult = (item) => {
        return SearchKeyFilter(item, ["activityName"], studentRegisterFilter) &&
            periods?.filter(e1 => item.activityPerformances.some(e2 => e1.periodId === e2.periode.periodId)).some((e) => e.checked);
    }

    return (
        <>
            <ContentLoader
                successCondition={searchStudentStatus === "success"}
                errorCondition={searchStudentStatus === "failed"}
                customError={
                    <>
                        {searchStudentStatus === "failed" &&
                            <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, alignItems: "center", textAlign: "center", m: 2 }}>
                                <Typography variant="h5">{resourceFinal[appLanguage].messages.SEARCH_STUDENT_NO_REGISTER}</Typography>
                            </Box>}
                    </>
                } content={
                    <Stack spacing={1} sx={{ width: 1 }}>
                        <ContentLoader
                            successCondition={registerContentStatus === "success"}
                            errorCondition={registerContentStatus === "failed"}
                            customError={
                                <>
                                    <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, alignItems: "center", textAlign: "center", m: 2 }}>
                                        <Typography variant="h5">{resourceFinal[appLanguage].messages.SEARCH_STUDENT_NO_REGISTER}</Typography>
                                    </Box>
                                </>
                            } content={
                                <>
                                    <>
                                        {registerSubprograms?.map((item, index) =>
                                            <RegisterSubprogramCard key={index} subprogram={item} />
                                        )}

                                        {registerBlocked && <>
                                            <Alert severity="error" sx={{ alignItems: "center" }}>
                                                <AlertTitle>{resourceFinal[appLanguage].messages.ABSENCE_BLOCK_ALERT}</AlertTitle>
                                            </Alert>
                                        </>}
                                    </>
                                    <Box sx={{ flex: '1 1 auto' }}>
                                        <Grid container spacing={1} justifyContent="center">
                                            {registerContent?.filter(handleFilterResult)?.map((item) =>
                                                <Grid key={item.performanceId}>
                                                    <RegisterCard
                                                        performance={item}
                                                        employeeMode
                                                        futureWarning={siomSettings?.enableSubscriptionOutsideProgram}
                                                        reasonMode={studentRegisterReasonMode}
                                                    />
                                                </Grid>
                                            )}

                                            {registerContent?.filter(handleFilterResult)?.length <= 0 && (
                                                <Grid size={{ xs: 12 }}>
                                                    <NoContentDisplay message={resourceFinal[appLanguage].messages.NO_REGISTER_CLINICS} />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                </>
                            }
                        />
                    </Stack>
                }
            />
        </>
    );
}
